import React from 'react';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel, KhachHang } from '@/types/schemas';
import { SearchFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
}

const DetailTab = ({ formMode }: DetailTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã đối tượng</Label>
        <SearchFieldV2<KhachHang>
          type='text'
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục khách hàng'
          className='w-[205px]'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã tài khoản</Label>
        <SearchFieldV2<AccountModel>
          type='text'
          name='tk'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          className='w-[205px]'
        />
      </div>
    </div>
  );
};

export default DetailTab;
